"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var debounce_1 = require("debounce");
$.fn.initMessagerie = function () {
    var $container = $(this);
    var route = $container.data("routeDestinataires");
    var reference = $container.attr("data-reference");
    var userIds = $container.attr("data-user-ids");
    $("body").on("click", ".toggle-new-member", function (e) {
        e.preventDefault();
        var $button = $(this);
        var $target = $($button.attr("href"));
        $target.removeClass("d-none");
        $target.find("select").select2("open");
    }).on("select2:select", ".new-member", function () {
        var $select = $(this);
        $.get({
            url: "/Messages/AddMember",
            method: "post",
            data: {
                threadId: $select.data("threadId"),
                userId: $select.val()
            }
        }).done(function () {
            document.location.reload();
        });
    }).on("select2:select", "select[name='ReferenceId']", function () {
        var $select = $(this);
        var $form = $select.parents("form");
        var $reference = $form.find("input[name='Reference']");
        var $destinataires = $form.find("select[name='MembresGuid']");
        var val = $select.val();
        $destinataires.get(0).disabled = val == null;
        var newReference = (_a = {}, _a[$select.data("referenceKey")] = val, _a);
        $reference.val(JSON.stringify(newReference));
        var _a;
    }).on("select2:select", "select[name='MembresGuid']", function (e) {
        if (e["params"].data.isEntreprise && JSON.parse(e["params"].data.isEntreprise)) {
            var $select_1 = $(this);
            var $form = $select_1.parents("form");
            var $reference = $form.find("input[name='Reference']");
            var affaire = $select_1.parents("form").find("select[name='ReferenceId']").val() || JSON.parse($reference.val())["AffaireId"];
            var val_1 = e["params"].data.id;
            $.get({
                url: "/Affaires/ListeUserIdsForTypeEntreprises",
                method: "get",
                data: {
                    id: affaire,
                    userId: val_1
                }
            }).done(function (data) {
                var results = data.results,
                    selected = $select_1.select2("data"),
                    newSelect = [];
                selected = selected.filter(function (s) {
                    return s.id !== val_1;
                });
                $select_1.html("");
                newSelect = $.map(selected, function (d) {
                    $select_1.append($("<option>", {
                        value: d.id,
                        text: d.text
                    }));
                    return d.id;
                });
                newSelect = $.merge(newSelect, $.map(results.filter(function (r) {
                    return selected.filter(function (s) {
                        return s.id === r.id;
                    }).length === 0;
                }), function (d) {
                    $select_1.append($("<option>", {
                        value: d.id,
                        text: d.text
                    }));
                    return d.id;
                }));
                $select_1.val(newSelect).trigger("change");
            });
        }
    }).on("click", ".quit-thread", function (e) {
        var $button = $(this);
        $.ajax({
            url: "/Messages/QuitThread",
            method: "post",
            data: {
                threadId: $button.data("threadId")
            }
        }).done(function () {
            document.location.reload();
        });
    }).on("click", "#onlyUnread", function (e) {
        $("#message-threads-titles").toggleClass("thread-onlyunread", this.checked);
    }).on("click", "#onlyUserIsReceiver", function (e) {
        $("#message-threads-titles").toggleClass("thread-onlyUserIsReceiver", this.checked);
    }).on("keyup", ".affaire-search", debounce_1.debounce(function () {
        var $search = $(this),
            val = $search.val(),
            currentValSearch = $search.data("currentSearch");
        val = val && val === 0 ? null : val.toUpperCase();
        if (val && val.length < 2 && val.length > currentValSearch) {
            return;
        }
        $search.data("currentSearch", val);
        $("#message-threads-titles > a").each(function () {
            var $el = $(this),
                code = $el.data("affaireCode").toUpperCase(),
                libelle = $el.data("affaireLibelle"),
                objet = $el.data("messageLibelle");
            $el.toggle(!val || code.indexOf(val) !== -1 || code.replace(/(-|\.|_)/g, '').indexOf(val) !== -1 || libelle.toUpperCase().indexOf(val) !== -1 || objet.toUpperCase().indexOf(val) !== -1);
        });
    }));
    //Coché par défaut
    if (!$("#isAdmin").val()) {
        $("#onlyUnread").trigger("click");
    }
    //Coché par défaut
    if ($("#onlyMessagesForMe").val()) {
        $("#onlyUserIsReceiver").trigger("click");
    }
    // Changement de volet
    $container.find("[data-thread-id]").on("shown.bs.tab", function (e) {
        var $tab = $(this);
        var threadId = $tab.data("threadId");
        var $thread = $("#message-threads");
        var goToLastMessage = function goToLastMessage() {
            var $messages = $thread.find("#messages-area"),
                $message = $messages.find("> .row:last");
            if ($message.length > 0) {
                $messages.animate({
                    scrollTop: $message.offset().top - $messages.offset().top + $messages.scrollTop()
                }, 0);
            }
        };
        var params = $.param({
            routeDestinataires: route,
            reference: reference,
            userIds: userIds
        });
        var url = threadId === "new" ? "/Messages/NewThread?" + params : "/Messages/Thread/" + threadId + "?" + params;
        // Charge le thread
        var submitFunc = function submitFunc() {
            {
                // Init form elements
                $thread.find(".select2").select2({
                    ajax: {
                        url: function url(params) {
                            params["id"] = $(this).parents("form").find("select[name='ReferenceId']").val();
                            return route + "?" + $.param(params);
                        }
                    }
                });
                var $forms = $thread.find(".new-message-form");
                // Formulaire de nouveau message
                $forms.submit(function (event) {
                    event.preventDefault();
                    var $form = $(this);
                    if (!$form.valid()) {
                        return $form;
                    }
                    // Barre de progression
                    var $progress = $form.find(".progress").removeClass("d-none");
                    var $progressBar = $progress.find(".progress-bar");
                    $progressBar.attr("aria-valuenow", 0);
                    $progressBar.width(0);
                    // Submit
                    var fd = new FormData($form.get(0));
                    fd.append("routeDestinataires", route);
                    $.ajax({
                        url: $form.attr("action"),
                        data: fd,
                        processData: false,
                        contentType: false,
                        type: $form.attr("method"),
                        xhr: function xhr() {
                            var xhr = $.ajaxSettings.xhr();
                            // Mise à jour de la barre de progression
                            if (xhr.upload) {
                                xhr.upload.addEventListener("progress", function (e) {
                                    if (!e.lengthComputable) {
                                        return;
                                    }
                                    var pct = e.loaded * 100 / e.total;
                                    $progressBar.width(pct + "%");
                                }, false);
                            }
                            return xhr;
                        },
                        success: function success(data) {
                            if (!data.success && data.success !== false) {
                                $("#message-threads").html(data);
                                submitFunc();
                                return;
                            }
                            var $log = $form.find(".submit-log");
                            $log.toggleClass("d-none", data.success);
                            if (data.success == false) {
                                $progress.addClass("d-none");
                                $log.text(data.message);
                                return;
                            } else {
                                var url = document.location.href;
                                if (/\?/.test(url)) {
                                    url = url.replace(/\?.*$/, "#thread-" + data.id);
                                    document.location.assign(url);
                                } else {
                                    if (/#thread-new/.test(url)) {
                                        url = url.replace(/#thread-new.*$/, "#thread-" + data.id);
                                        document.location.assign(url);
                                    }
                                    document.location.reload();
                                }
                            }
                        }
                    });
                    return $form;
                });
                // On remonte le tab en visu au chargement de la page
                var $parent = $tab.parent().parent();
                $parent.animate({
                    scrollTop: $tab.offset().top - $parent.offset().top + $parent.scrollTop()
                }, 100);
                //On descend le thread au dernier message
                goToLastMessage();
            }
        };
        $thread.load(url, submitFunc);
    });
    return $container;
};
$(".messagerie").initMessagerie();


//////////////////
// WEBPACK FOOTER
// ./_wwwsrc/js/Messages/index.ts
// module id = 603
// module chunks = 0